import type { AxiosResponse } from "axios";
import { InitService } from "./init.service";
import type Item from "./model/item";

export class MunicipioService extends InitService {
    public obterMunicipios(codUf: number): Promise<AxiosResponse<Array<Item>>> {
        return this.get(`MunicipioUf/ObterMunicipios/${codUf}`, true);
    }
}

const municipioService = new MunicipioService();
export default municipioService;